import { z } from 'zod';
import { positiveDecimal } from './primitives.js';

const code = z.string().trim().regex(/^[A-Z0-9_-]{2,30}$/, { error: 'Code en majuscules (A-Z, 0-9, _ -)' });
const name = z.string().trim().min(2).max(160);

export const workDomainSchema = z.object({ code, name, description: z.string().trim().max(500).nullable().optional() });
export const workLotSchema = z.object({ domainCode: code, parentCode: code.nullable().optional(), code, name });

const variable = z.object({
  key: z.string().regex(/^[A-Za-z_][A-Za-z0-9_]{0,20}$/, { error: 'Variable : lettres, chiffres et _ ' }),
  label: z.string().trim().min(1).max(80),
  unit: z.string().trim().max(20).default(''),
});

/** Ouvrage de l'entreprise : sa formule est vérifiée (syntaxe, unités) par le moteur. */
export const workItemSchema = z.object({
  domainCode: code,
  lotCode: code,
  designation: name,
  unit: z.string().trim().min(1).max(20),
  formula: z.string().trim().min(1).max(500),
  variables: z.array(variable).min(1).max(20),
  chapterCode: code.default('AUTRES'),
});
export const workItemUpdateSchema = z.object({
  version: z.number().int().positive(),
  designation: name.optional(),
  unit: z.string().trim().min(1).max(20).optional(),
  formula: z.string().trim().min(1).max(500).optional(),
  variables: z.array(variable).min(1).max(20).optional(),
});

/** Saisie d'une dimension, dans l'unité choisie (m, cm, mm…). */
const measure = z.object({ value: positiveDecimal, unit: z.string().trim().max(20).optional() });

export const calculatorInputSchema = z.object({ values: z.record(z.string().max(30), measure) });

const target = z.union([
  z.object({ projectId: z.uuid() }),
  z.object({ newProject: z.object({ name, clientName: z.string().trim().max(160).nullable().optional(), location: z.string().trim().max(160).nullable().optional() }) }),
]);

export const calculatorApplySchema = z.object({
  values: z.record(z.string().max(30), measure),
  target,
  label: z.string().trim().max(120).optional(),
  concrete: z.string().trim().max(30).optional(),
  masonry: z.string().trim().max(30).optional(),
});

const opening = z.object({ width: positiveDecimal, height: positiveDecimal, count: positiveDecimal.default('1') });

export const itemCalculateSchema = z.object({ values: z.record(z.string().max(30), measure), quantity: positiveDecimal.default('1'), openings: z.array(opening).max(50).optional() });
export const itemApplySchema = itemCalculateSchema.extend({ target, concrete: z.string().trim().max(30).optional(), masonry: z.string().trim().max(30).optional() });

export const domainValidateSchema = z.object({ note: z.string().trim().max(500).optional() });
